/**
 * Returns the current admin session TOKEN (opaque random string from admin_sessions table).
 * Falls back to the admin row id only for legacy sessions stored before the token rollout.
 */
export function getAdminSessionId(): string | null {
  try {
    const stored = sessionStorage.getItem("kf-admin-session");
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    return parsed?.token || parsed?.id || null;
  } catch {
    return null;
  }
}
